﻿import controller from '../../../../Resources/Scripts/_Shared/controller';

function shortcutsBlock(context) {
  const itemsToShow = context.getAttribute('data-items') && Number(context.getAttribute('data-items'));
  const listItems = context.querySelectorAll('.shortcutsblock__list > li');
  const expandButton = context.querySelector('.shortcutsblock__button');
  let isExpanded = false;

  function init() {
    if (!expandButton) return
    loopItems();

    expandButton.addEventListener('click', function () { 
      isExpanded = !isExpanded;
      context.classList.toggle('shortcutsblock--showall');
      loopItems();
    });
  }

  function loopItems() {
    for (let i = 0; i < listItems.length; i++) {
      const singleListItem = listItems[i];
      const singleListItemLink = singleListItem.querySelector('a.shortcutsblock__list__link');

      if ((i + 1) > itemsToShow && !isExpanded)
        singleListItemLink.setAttribute('tabindex', '-1');
      else if (isExpanded)
        singleListItemLink.removeAttribute('tabindex');
    }
	}

  return {
    init
  };
}

controller.add('shortcuts-block', shortcutsBlock);